export default "__VITE_ASSET__uSKGtdLP__"